import { Injectable } from '@angular/core';

import { Storage } from '@ionic/storage-angular';
import { Absence } from '@spotter/models/absence';
import { Sighting } from '@spotter/models/sighting';

//import { Absence, Sighting } from '../../models/models';

export interface KeyedUploadableSighting
{
    key: string;
    sighting: Sighting;
}

export interface KeyedUploadableAbsence
{
    key: string;
    absence: Absence;
}

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private _storage?: Storage;
    constructor(private storage: Storage) {}
    
    /** Creates the storage database */
    async init() {
        this._storage = await this.storage.create();
    }

    /** Gets a key from the DB */
    async get(key: string) {
        if(!this._storage)
            await this.init() ;
        return await this._storage?.get(key) ;
    }

    async remove(key: string) {
        if(!this._storage)
            await this.init() ;
        return await this._storage?.remove(key) ;
    }

     /** Gets all storage */
   /* async getAllStartingWith(keySearch: string) {
        if(!this._storage)
            await this.init();

        let results: KeyedUploadableSighting[] = []
        let keys = await this._storage?.keys();
        for (const key of keys!)
        {
            let value = await this.get(key);
            if (key.startsWith(keySearch))
                results.push({key: key, sighting: value});
        }

        return results;
    } */

    async getAllUnsyncedSightings() {
        if(!this._storage)
            await this.init();

        let results: KeyedUploadableSighting[] = []
        let keys = await this._storage?.keys();
        for (const key of keys!)
        {
            let value = await this.get(key);
            if (key.startsWith("s."))
                results.push({key: key, sighting: value});
        }

        return results;
    }

    async getAllUnsyncedAbsences() {
        if(!this._storage)
            await this.init();

        let results: KeyedUploadableAbsence[] = []
        let keys = await this._storage?.keys();
        for (const key of keys!)
        {
            let value = await this.get(key);
            if (key.startsWith("a."))
                results.push({key: key, absence: value});
        }

        return results;
    }

    /** Sets a key in the DB */
    async set(key: string, data: any) {
        if(!this._storage)
            await this.init() ;
        return await this._storage?.set(key, data) ;
    }
}